import { $ } from "./imports";

const hamburguerMenu = () => {
    let hamburguerBtn = document.querySelector('.hamburger');
    let header = document.querySelector('.header');

    hamburguerBtn.addEventListener("click", function() {
        this.classList.toggle("is-active");
        header.classList.toggle("active");
        // Bloqueamos scroll body
        $('body').toggleClass('overflow-hidden');
    }, false);
}

export default hamburguerMenu;